import React, {Component} from "react";
import ServiceCard from "../ServiceCard";
import NoData from "../../NoData";
import {withTranslate} from "react-redux-multilingual";

class BookWithDoctorServices extends Component {

    state = {
        popUpStatus: false,
        selectedServices: [],
        selectedServicesIds: [],
        servicesTags: false,
        checked: false,
    };

    componentDidMount() {
        window.addEventListener("click", this.handleWindowOnclick);
    }
    componentWillUnmount() {
        // make sure you remove the listener when the component is destroyed
        document.removeEventListener('click', this.handleWindowOnclick, false);
    }
    handleWindowOnclick = (e) => {
        let doctorServices = document.getElementById("doctor-services");
        if (e.target === doctorServices) {
            this.changePopUpStatus(e, "close")
        }
    };
    changePopUpStatus = (e, status) => {
        e.preventDefault();

        if (status === "close") {
            this.setState({
                popUpStatus: false,
            });
            document.getElementById("about-doctor").style.zIndex = "1";
            document.getElementById("about-author").style.zIndex = "1";
            document.getElementById("subscribe").style.zIndex = "1";
            document.getElementById("footer").style.zIndex = "1";
            document.getElementById("auth-pop-up").style.width = "0";
        } else {
            this.setState({
                popUpStatus: true,
            })
            document.getElementById("about-doctor").style.zIndex = "-1";
            document.getElementById("about-author").style.zIndex = "-1";
            document.getElementById("subscribe").style.zIndex = "-1";
            document.getElementById("footer").style.zIndex = "-1";
            document.getElementById("auth-pop-up").style.width = window.innerWidth + "px";
            document.getElementById("auth-pop-up").style.height = window.innerHeight + "px";
        }
    };
    showDoctorServices = (e) => {
        this.changePopUpStatus(e, "open");
    };

    handleCheckBoxChange = (e, value) => {
        this.setState({
            checked: true
        });
        /* this.setState({
             servicesTags: false
         });*/
        if (this.state.selectedServices.length > 0) {
            /* for (let i = 0; i < this.state.selectedServices.length; i++) {
                 if (this.state.selectedServices[i].id !== JSON.parse(e.target.value).id) {
                     console.log("msh mawgooda");
                     this.setState({
                         selectedServices: [
                             ...this.state.selectedServices,
                             {...JSON.parse(e.target.value), checked: true}
                         ],
                         selectedServicesIds: [...this.state.selectedServicesIds, (JSON.parse(e.target.value).id)]
                     });
                 } else {
                     this.removeService(JSON.parse(e.target.value))
                 }
             }
 */
            const isSelected = this.state.selectedServices.find(item => {
                return value.id === item.id
            });

            if (!isSelected) {
                this.setState({
                    selectedServices: [
                        ...this.state.selectedServices,
                        value
                    ],
                    selectedServicesIds: [...this.state.selectedServicesIds, value.id]
                }, () => {
                    this.props.setServices(JSON.stringify(this.state.selectedServicesIds))
                });
            } else {
                this.removeService(value)
            }
        } else {
            this.setState({
                selectedServices: [
                    ...this.state.selectedServices,
                    value
                ],
                selectedServicesIds: [...this.state.selectedServicesIds, value.id]
            }, () => {
                this.props.setServices(JSON.stringify(this.state.selectedServicesIds))
                // localStorage.setItem('servicesToReserve', JSON.stringify(this.state.selectedServicesIds));
            });
        }

    };
    addServices = async (e) => {
        // await this.props.setServices(this.state.selectedServicesIds);
        this.changePopUpStatus(e, "close");
        // await localStorage.setItem('servicesToReserve', this.state.selectedServices);
        this.setState({
            servicesTags: true,
        });
    };

    removeService(service) {
        let filteredSelectedServices = this.state.selectedServices.filter(item => item.id !== service.id);
        let filteredSelectedServicesIds = this.state.selectedServicesIds.filter(item => item !== service.id);
        this.setState({
            selectedServices: filteredSelectedServices,
            selectedServicesIds: filteredSelectedServicesIds
        }, () => {
            this.props.setServices(JSON.stringify(this.state.selectedServicesIds))
        });
    }


    checkIfServiceExists(propsId) {
        const isSelected = this.state.selectedServices.find(item => {
            return propsId === item.id
        });
        if (!isSelected) {
            return false
        }
        return true;
    }

    render() {
        const servicesList = this.props.doctor && this.props.doctor.services.length ? this.props.doctor.services.map((service, index) => {
            return (
                <div id="service" key={index}>
                    <label className="check-container">
                        <ServiceCard language={this.props.language} service={service} doctor={this.props.doctor}/>
                        <input id={"service-input-" + service.id} className="service-checkbox " type="checkbox"
                               value={JSON.stringify(service)}
                               onChange={(e) => this.handleCheckBoxChange(e, service)}
                               checked={this.checkIfServiceExists(service.id)}
                        />
                        <span className="checkmark"></span>
                    </label>
                </div>
            )
        }) : (<NoData image="services"/>);

        const cachedServicesList = this.state.selectedServices && this.state.selectedServices.length ? this.state.selectedServices.map((service, index) => {
            return (
                <div className="service-tag" key={index}>
                     <span className="block shadow-4d service-tag-span">
                         {service.name}
                         <i className="fas fa-times pull-right"
                            onClick={() => this.removeService(service)}></i>
                     </span>
                </div>
            )
        }) : (<NoData image="services"/>);
        return (
            <div className="doctor-services-prices">
                <div className="doctor-services-area">
                    {
                        this.state.selectedServices.length > 0 ?
                            <div className="content-cached-services" hidden={this.state.servicesTags === false}>
                                <p className="full-width">{this.props.translate('services') + ":"}</p>
                                {cachedServicesList}
                            </div> : null
                    }
                    <div className="content cursor-pointer" id="doctor-services"
                         onClick={(e) => this.showDoctorServices(e)}>
                        <i className="fas fa-plus"></i>
                        <p className="capitalized">{this.props.translate('add_services') + " " + "(" + " " + this.props.translate('optional') + " " + ")"}</p>
                    </div>
                </div>


                <div hidden={this.state.popUpStatus === false}
                     className="pop-up" id="auth-pop-up">
                    <div className="flex-align-center">
                        {/*<a href="/" className="closebtn"*/}
                        {/*onClick={(e) => this.changePopUpStatus(e, "close")}>&times;</a>*/}
                        <img onClick={(e) => this.changePopUpStatus(e, "close")}
                             src="/images/close_button.png"
                             alt="close" className="closebtn cursor-pointer"/>
                        <div className="pop-up-area">
                            {this.props.doctor && this.props.doctor.services && this.props.doctor.services.length ?
                                <div className="row doctor-services-list">
                                    <p className="services-info">
                                        <i className="fas fa-info-circle"></i>
                                        {" " +this.props.translate('discount_premium_user')}</p>
                                    <div className="col-md-12">
                                        {servicesList}
                                    </div>
                                    <div className="add-services-btn">
                                        <div className="cursor-pointer"
                                             onClick={(e) => this.addServices(e)}>{this.props.translate('add_services')}</div>
                                    </div>
                                </div> : null}
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}

export default (withTranslate(BookWithDoctorServices));